
import { LOCALE_ID, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import {RouterModule} from "@angular/router";
import { registerLocaleData, LocationStrategy, HashLocationStrategy, DecimalPipe, PathLocationStrategy } from '@angular/common';
import { AppRoutingModule } from "./app.routes";
import { AppComponent } from './app.component';
import { BsDropdownModule} from 'ngx-bootstrap/dropdown';

import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AngularMaterialModule } from './angular-material-module/angular-material.module';

// App views
import {DashboardsModule} from "./views/dashboards/dashboards.module";
import {AppviewsModule} from "./views/appviews/appviews.module";
import {PersonalModule} from "./views/personal/personal.module";

// App modules/components
import {LayoutsModule} from "./components/common/layouts/layouts.module";
import { ModalModule } from 'ngx-bootstrap/modal';

// importar locales
import localeEsAr from '@angular/common/locales/es-AR';
import { BlocklyModule } from './components/blockly/blockly.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

import {OrganizationChartModule} from 'primeng/organizationchart';
import {CheckboxModule} from 'primeng/checkbox';
import { FormatearImportePipe } from './components/common/pipes/formatear-importe.pipe';
import { JwtModule } from '@auth0/angular-jwt';
import { ErrorHandlerService } from './core/services/error-handler.service';
import { NotFoundComponent } from './components/common/not-found/not-found.component';

import { SocialLoginModule, SocialAuthServiceConfig } from 'angularx-social-login';
import{GoogleLoginProvider,FacebookLoginProvider} from 'angularx-social-login';
import { SpinnerModule } from './components/shared/spinner/spinner.module';
import { SpinnerInterceptor } from './components/shared/interceptors/spinner.interceptor';
import { AuthoriceInterceptor } from './components/shared/interceptors/authorize.interceptor';

export function tokenGetter()
{
    return localStorage.getItem("Token");
}


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// registrar los locales con el nombre que quieras utilizar a la hora de proveer
registerLocaleData(localeEsAr, 'es-Ar');

@NgModule({
  declarations: [
    AppComponent,
    FormatearImportePipe,
    NotFoundComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    DashboardsModule,
    LayoutsModule,
    AppviewsModule,
    ReactiveFormsModule,    
    PersonalModule,
    BrowserAnimationsModule,
    AngularMaterialModule,
    TranslateModule.forRoot({
        defaultLanguage: 'es',
        useDefaultLang: true,
        loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
      }
    }),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    BlocklyModule,
    AppRoutingModule,
    
    MatAutocompleteModule,
    OrganizationChartModule,
    CheckboxModule,
    JwtModule.forRoot({
            config: {
                tokenGetter: tokenGetter,
                whitelistedDomains: [
                    'localhost:5000', 'localhost:44390'
                ],
            }
    }),
    SocialLoginModule,
    HttpClientModule,
    SpinnerModule
  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy },
    //providers: [{ provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: LOCALE_ID, useValue: 'es-Ar' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthoriceInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true
    },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider('421971847116-po3mog39bovadhcrejsr7uf9829sei6f.apps.googleusercontent.com')
          },
        ],
      } as SocialAuthServiceConfig
    }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
